// Framework-free (no Angular/Firebase imports) so this can be shared by both
// env-picker-overlay.ts (used from src/main.ts before Angular exists) and
// RemoteConfigService (used after bootstrap) without either pulling in the
// other's dependencies.

export interface EnvironmentDirectoryEntry {
  baseUrl: string
  webHost: string
  firebaseTenantId: string
}

export type EnvironmentDirectory = Record<string, EnvironmentDirectoryEntry>

/**
 * Remote Config publishes `environment_directory` with snake_case keys
 * (base_url/web_host/firebase_tenant_id - the naming convention shared with
 * the Flutter apps), so raw parsed JSON must be normalized into this
 * interface's camelCase shape before use. Returns null if nothing usable
 * could be extracted, so callers can fall back to bundled defaults.
 */
export function normalizeEnvironmentDirectory(raw: unknown): EnvironmentDirectory | null {
  if (!raw || typeof raw !== 'object') {
    return null
  }
  const normalized: EnvironmentDirectory = {}
  for (const [key, value] of Object.entries(raw as Record<string, any>)) {
    if (!value || typeof value !== 'object') {
      continue
    }
    const baseUrl = value.baseUrl ?? value.base_url
    const firebaseTenantId = value.firebaseTenantId ?? value.firebase_tenant_id
    if (!baseUrl || !firebaseTenantId) {
      continue
    }
    normalized[key] = { baseUrl, webHost: value.webHost ?? value.web_host ?? '', firebaseTenantId }
  }
  return Object.keys(normalized).length ? normalized : null
}
